import React from 'react'
import { isRouteAllowed, reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { faHeartRate } from '@fortawesome/pro-regular-svg-icons/faHeartRate'
import { faHeartRate as faHeartSolidRate } from '@fortawesome/pro-solid-svg-icons/faHeartRate'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import useTranslations from 'src/hooks/useTranslations'
import useUserData from 'src/hooks/useUserData'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

const baseUrlHorizon = getEnvVariableValue(VARIABLES.OLD_HORIZON_BASE_URL)

export default function HealthMenu({ parentIsCollapsed, isOpen, onClick }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const userData = useUserData()
    return (
        <MainMenuItem
            icon={faHeartRate}
            iconActive={faHeartSolidRate}
            title={t('Health')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
        >
            {isRouteAllowed(userData, 'mon') &&
                isFeatureEnabled(FEATURES.MON_DASHBOARD_MENU_OPTION) && (
                    <MainMenuItem title={t('Monitoring')} to={reverse('mon')} />
                )}
            {isRouteAllowed(userData, 'health') && (
                <MainMenuItem
                    title={t('KPIs')}
                    to={
                        isFeatureEnabled(FEATURES.HEALTH_MENU_OPTION)
                            ? reverse('health')
                            : {
                                  pathname: `${baseUrlHorizon}/health`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.HEALTH_MENU_OPTION)
                    }
                />
            )}
            {isRouteAllowed(userData, 'runbook') && (
                <MainMenuItem
                    title={t('Runbooks')}
                    to={
                        isFeatureEnabled(FEATURES.HEALTH_RUNBOOKS_MENU_OPTION)
                            ? reverse('runbook')
                            : {
                                  pathname: `${baseUrlHorizon}/health/runbook`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.HEALTH_RUNBOOKS_MENU_OPTION)
                    }
                />
            )}
            {isRouteAllowed(userData, 'ssr-dashboards') && (
                <MainMenuItem
                    title={t('SSR Dashboards')}
                    to={reverse('ssr-dashboards')}
                />
            )}
        </MainMenuItem>
    )
}
